import * as users from 'api/userApi';

export async function getUserADInfo() {
    try {
        const response = await users.getUserInfo();
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des données utilisateur :', error);
        throw new Error('Erreur lors de la récupération des données utilisateur.');
    }
}

export async function getUserBDDInfo() {
    try {
        const response = await users.getUser();
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des données utilisateur :', error);
        throw new Error('Erreur lors de la récupération des données utilisateur.');
    }
}

export async function insertUser(agency, browser) {
    try {
        const response = await users.insertUser(agency, browser);
        return response;
    } catch (error) {
        console.error('Erreur lors de l\'insertion de l\'utilisateur :', error);
        throw new Error('Erreur lors de l\'insertion de l\'utilisateur.');
    }
}

export async function updateUser(fieldsToUpdate) {
    try {
        const response = await users.updateUser(fieldsToUpdate);
        return response;
    } catch (error) {
        console.error('Erreur lors de la mise à jour de l\'utilisateur :', error);
        throw new Error('Erreur lors de la mise à jour de l\'utilisateur.');
    }
}
